/// <amd-module name="Artifacts/Root/components/PermanentDeleteModal" />

import { CommandPanel } from "Artifacts/Root/components/CommandPanel";
import { ComponentState } from "Artifacts/Root/Constants";
import { registerModal } from "Artifacts/Root/containers/ModalManager";
import { connectDynamicModules } from "Artifacts/Root/redux";
import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import { RootModule } from "Artifacts/Root/redux/Module";
import * as Res from "Artifacts/Root/Resources";
import { IPackageVersionIdentity } from "Artifacts/Root/types";
import * as React from "react";
import { connect } from "react-redux";

export interface IPermanentDeleteModalProps {
  onDismiss: () => void;
  onPermanentDelete: () => void;
  versions: IPackageVersionIdentity[];
}

interface IMapStateToProps {
  componentState: ComponentState;
}

export const PermanentDeleteModalId = "PermanentDeleteModal";

const PermanentDeleteModal: React.FC<IPermanentDeleteModalProps & IMapStateToProps> = ({
  onDismiss,
  onPermanentDelete,
  versions,
  componentState,
}) => {
  return (
    <CommandPanel
      title={Res.PermanentDeleteModal_Title}
      description={Res.PermanentDeleteModal_Body_MultiplePackages}
      packages={versions}
      onDismiss={onDismiss}
      onSubmit={onPermanentDelete}
      submitButtonComponentState={componentState}
      submitButtonText={Res.PermanentDeleteModal_PermanentlyDelete}
      isSubmitButtonDanger={true}
    ></CommandPanel>
  );
};

const mapStateToProps = (state: IRootModuleState): IMapStateToProps => {
  const rootState = state.rootState;
  return {
    componentState: rootState.permDeleteCommandState,
  };
};

const ConnectedPermanentDeleteModal = connectDynamicModules(
  connect(mapStateToProps)(PermanentDeleteModal),
  [RootModule],
);

registerModal(PermanentDeleteModalId, ConnectedPermanentDeleteModal);

export { PermanentDeleteModal };
